import book11 from '../../media/book11.png';
import book10 from '../../media/book10.jpg';
import book9 from '../../media/book9.jpg';
import book8 from '../../media/book8.jpg';
import book7 from '../../media/book7.png';
import book6 from '../../media/book6.png';
import book5 from '../../media/book5.png';
import book4 from '../../media/book4.png';
import book3 from '../../media/book3.png';
import book2 from '../../media/book2.png';
import book1 from '../../media/book1.png';
import book0 from '../../media/book0.png';

export const bookCoverMap = {
  book11,
  book10,
  book9,
  book8,
  book7,
  book6,
  book5,
  book4,
  book3,
  book2,
  book1,
  book0,
};
